import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnCreate } from '@helpers/product-events';

export const inboxTemplatesService = {
    addOrUpdateInboxTemplate,
    deleteInboxTemplate,
    getAllInboxTemplates,
};

function getAllInboxTemplates() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/inbox/message-templates?returnAll=true`, requestOptions).then(handleResponse);
}

function addOrUpdateInboxTemplate(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/inbox/message-templates`, requestOptions)
        .then(handleResponse)
        .then(captureOnCreate(data, ProductEvent.InboxTemplateCreated));
}

function deleteInboxTemplate(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/inbox/message-templates/${id}`, requestOptions).then(handleResponse);
}
